import React, { useContext } from 'react';
import { View, colors } from '@fairygodboss/ui';
import { renderToStaticMarkup } from 'react-dom/server';
import window from 'global/window';
import ReactionBar from '../../../ReactionBar/ReactionBar';
import { CommunityContext } from '../../../../../contexts/ContextCreator';

/*
This component wraps our current ReactionBar with updated styles
*/

const CopyLink = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.89324 11.1844L5.26217 8.8155C5.58925 8.48841 6.11955 8.48841 6.44663 8.8155C6.75035 9.11921 6.77204 9.59816 6.51171 9.92691L6.44663 9.99996L4.0777 12.3689C3.09646 13.3501 3.09646 14.941 4.0777 15.9223C5.0239 16.8685 6.53699 16.9023 7.52368 16.0237L7.63109 15.9223L10 13.5534C10.3271 13.2263 10.8574 13.2263 11.1845 13.5534C11.4882 13.8571 11.5099 14.336 11.2496 14.6648L11.1845 14.7378L8.81556 17.1067C7.18015 18.7421 4.52864 18.7421 2.89324 17.1067C1.30087 15.5144 1.25897 12.9587 2.76753 11.3156L2.89324 11.1844ZM11.1845 2.89318C12.8199 1.25778 15.4714 1.25778 17.1068 2.89318C18.7422 4.52858 18.7422 7.18009 17.1068 8.8155L14.7379 11.1844C14.4108 11.5115 13.8805 11.5115 13.5534 11.1844C13.2263 10.8573 13.2263 10.327 13.5534 9.99996L15.9223 7.63103C16.9036 6.64979 16.9036 5.05888 15.9223 4.07764C14.9411 3.0964 13.3502 3.0964 12.3689 4.07764L10 6.44657C9.67294 6.77365 9.14264 6.77365 8.81556 6.44657C8.48848 6.11949 8.48848 5.58919 8.81556 5.2621L11.1845 2.89318ZM11.1845 7.63103C11.5116 7.30395 12.0419 7.30395 12.3689 7.63103C12.696 7.95811 12.696 8.48841 12.3689 8.8155L8.81556 12.3689C8.48848 12.696 7.95817 12.696 7.63109 12.3689C7.30401 12.0418 7.30401 11.5115 7.63109 11.1844L11.1845 7.63103Z"
            fill="#353535"
        />
    </svg>
);

const Facebook = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="20" height="20" rx="1" fill="#425893" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.4487 5.13332H13.8572V2.81669C13.6146 2.78538 12.7789 2.71423 11.8059 2.71423C9.77503 2.71423 8.38412 3.92093 8.38412 6.13795V8.17852H6.14288V10.7684H8.38412V17.2857H11.1309V10.7684H13.2815L13.6234 8.17852H11.1309V6.39409C11.1309 5.6456 11.3442 5.13332 12.4487 5.13332Z"
            fill="white"
        />
    </svg>
);

const LinkedIn = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="20" height="20" rx="1" fill="#3375B0" />
        <path
            d="M6.57185 16H4.19783V7.29526H6.57185V16ZM5.38484 6.29185C4.62041 6.29185 4 5.66669 4 4.89592C4 4.12516 4.62041 3.5 5.38484 3.5C6.14928 3.5 6.76969 4.12516 6.76969 4.89592C6.76969 5.66669 6.15007 6.29185 5.38484 6.29185ZM16.0679 16H13.6939V11.5653C13.6939 8.9001 10.5286 9.10189 10.5286 11.5653V16H8.15453V7.29526H10.5286V8.69198C11.6333 6.64558 16.0679 6.49443 16.0679 10.6513V16Z"
            fill="white"
        />
    </svg>
);

const ShareIcon = ({ color }) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.237144 20C0.237144 20 9.53978e-05 19.9851 0 19.7262C0.193869 16.9344 2.83476 7.74314 13.3315 8.99233V4.60989C13.3315 4.03812 13.9905 3.86837 14.3445 4.10065L22.5627 10.5167C23.1198 10.9135 23.1698 11.8985 22.5627 12.3759L14.3476 19.0792C13.9457 19.4119 13.3315 19.2289 13.3315 18.7964V14.208C13.3315 14.208 6.29194 13.2836 0.72006 19.7262C0.509506 19.9696 0.417291 20 0.237144 20Z"
            fill={color}
        />
    </svg>
);

const CommentIcon = ({ color }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.40002 16L1.95973 19.3897C1.33116 19.8925 0.400024 19.445 0.400024 18.64V3.28002C0.400024 1.68944 1.68944 0.400024 3.28002 0.400024H16.72C18.3106 0.400024 19.6 1.68944 19.6 3.28002V12.88C19.6 14.4706 18.1906 16 16.6 16H6.40002Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.40002 16L1.95973 19.3897C1.33116 19.8925 0.400024 19.445 0.400024 18.64V3.28002C0.400024 1.68944 1.68944 0.400024 3.28002 0.400024H16.72C18.3106 0.400024 19.6 1.68944 19.6 3.28002V12.88C19.6 14.4706 18.1906 16 16.6 16H6.40002ZM2.8 16L5.56032 14.0504C5.73054 13.9142 6.18201 13.6 6.4 13.6H16C16.6 13.6 17.2 13 17.2 12.4V4.00002C17.2 3.40002 16.72 2.80002 16 2.80003L4 2.80002C3.46981 2.80002 2.8 3.46982 2.8 4.00002V16Z"
                fill={color}
            />
        </svg>
    );
};

const HeartIcon = ({ color }) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.4 2C14.7096 2 13.1677 2.6298 12 3.66555C10.8323 2.6298 9.29038 2 7.6 2C3.95492 2 1 4.92852 1 8.54103C1 13.8136 6.47643 18.9097 11.5362 21.8829C11.7923 22.0405 12.2116 22.0383 12.4671 21.8807C17.4934 18.8977 23 13.8134 23 8.54103C23 4.92852 20.0451 2 16.4 2ZM12.0062 19.588C6.56672 16.0638 3.19998 11.9469 3.19998 8.54102C3.19998 6.13268 5.16993 4.18033 7.59998 4.18033C8.69947 4.18033 9.73062 4.57866 10.5328 5.29019L11.5913 6.22912C11.8201 6.43206 12.183 6.42934 12.4087 6.22912L13.4672 5.29019C14.2693 4.57866 15.3005 4.18033 16.4 4.18033C18.83 4.18033 20.8 6.13268 20.8 8.54102C20.8 12.0345 17.4458 16.0638 12.0062 19.588Z"
            fill={color}
        />
        <path
            d="M3.19995 8.54098C3.19995 11.9469 6.56669 16.0638 12.0062 19.588C17.4457 16.0638 20.7999 12.0345 20.7999 8.54098C20.7999 6.13264 18.83 4.1803 16.4 4.1803C15.3005 4.1803 14.2693 4.57863 13.4672 5.29015L12.4087 6.22908C12.1829 6.4293 11.82 6.43203 11.5913 6.22908L10.5327 5.29015C9.73059 4.57863 8.69944 4.1803 7.59995 4.1803C5.1699 4.1803 3.19995 6.13264 3.19995 8.54098Z"
            fill={color}
            stroke={color}
        />
    </svg>
);

const engagementColors = {
    normal: colors.secondary[20],
    hover: colors.secondary[40],
    liked: colors.alert.base,
};

const svgURL = (component, state) => {
    const color = engagementColors[state] || engagementColors.normal;

    const components = {
        like: <HeartIcon color={color} />,
        comment: <CommentIcon color={color} />,
        share: <ShareIcon color={color} />,
        linkedIn: <LinkedIn />,
        facebook: <Facebook />,
        copyLink: <CopyLink />,
    };

    const url = `url("data:image/svg+xml,${encodeURIComponent(
        renderToStaticMarkup(components[component])
    )}")`;

    return url;
};

const svgPopupStyle = (svgType) => {
    return {
        padding: '0px',
        margin: '0px !important',
        height: '36px',
        '.icon-container': {
            display: 'none',
        },
        '.label': {
            backgroundRepeat: 'no-repeat',
            paddingLeft: '39px',
            backgroundImage: svgURL(svgType),
            backgroundPositionY: '6px',
            backgroundPositionX: '11px',
        },
        '.label.copied-styling': {
            fontWeight: '700 !important',
        },
        ':hover': {
            backgroundColor: '#F0F2F5 !important',
            '.label': {
                fontWeight: `600 !important`,
            },
        },
    };
};

export const SocialCTA = ({ communityContext }) => {
    const {
        hash,
        isLoggedIn,
        editorRef,
        isCommunityDiscussionType,
    } = communityContext();
    const { getContent } = useContext(CommunityContext);
    const content = getContent(hash);
    const heartColor = content?.userLiked ? 'liked' : 'normal';

    const svgBaseStyle = () => {
        return {
            paddingTop: '2px',
            svg: {
                marginRight: '5px !important',
            },
            p: {
                textTransform: 'capitalize',
                fontFamily: 'Open Sans !important',
                fontSize: '14px !important',
                fontWeight: '400 !important',
                marginBottom: '6px !important',
                color: colors.neutral[100],
                ':not(..component-Community-ReactionBar-CommunityShareButton-CommunitySharePopup)': {
                    lineHeight: '18px !important',
                },
            },
        };
    };

    return (
        <View
            display="flex"
            alignItems="center"
            pb="36px"
            pt="32px"
            height="30px"
            fontSize="14px"
            lineHeight="18px"
            letterSpacing="-0.4px"
            position="relative"
        >
            <View
                display="flex"
                css={{
                    '.component-Community-ReactionBar': {
                        paddingLeft: '0px !important',
                        paddingRight: '0px !important',
                        '.wrap-auth-div': {
                            margin: '0px !important',
                        },
                    },
                    '.component-Community-ReactionBar-CommunityShareButton-CommunitySharePopup': {
                        lineHeight: '2.23 !important',
                        width: '160px',
                        boxShadow: '0px 4px 8px rgba(53, 53, 53, 0.2)',
                        borderRadius: '6px',
                        border: 'none',
                        padding: '8px 0',
                        right: '-84px !important',
                        bottom: '-146px !important',
                        marginBottom: '20px !important',
                        marginRight: window.innerWidth < 410 ? '72px' : '0px',
                    },

                    '.component-Community-ReactionBar-CommunityLikeButton': {
                        // svg: {
                        //     display: 'none',
                        // },
                        ...svgBaseStyle('like', heartColor),
                        marginRight: '14px',
                    },
                    '.component-Community-ReactionBar-CommunityCommentButton': {
                        // svg: {
                        //     display: 'none',
                        // },
                        ...svgBaseStyle('comment'),
                        // backgroundPositionY: '2px',
                    },
                    '.component-Community-ReactionBar-CommunityShareButton': {
                        // '.component-Icons-ShareIcon': {
                        //     display: 'none',
                        // },
                        ...svgBaseStyle('share'),
                        // paddingLeft: '22px',
                        marginLeft: '16px !important',
                        button: {
                            marginRight: '2px',
                        },
                        '.button-label': {
                            marginBottom: '10px !important',
                        },
                    },
                    '.component-Community-ReactionBar-SmallLinkedInButton': {
                        ...svgPopupStyle('linkedIn'),
                        p: {
                            marginTop: '7px',
                        },
                    },
                    '.component-Community-ReactionBar-SmallFacebookButton': {
                        ...svgPopupStyle('facebook'),
                        p: {
                            marginTop: '7px',
                        },
                    },
                    '.component-Community-ReactionBar-CopyLinkButton': {
                        p: {
                            margin: '0 0 0 6px !important',
                        },
                        '.component-Icons-LinkIcon': {
                            display: 'none',
                        },
                        ...svgPopupStyle('copyLink'),
                        paddingTop: '2px !important',
                    },
                }}
            >
                <ReactionBar
                    hash={hash}
                    location="singleContent"
                    showLikeLabel
                    onCommentClick={() => {
                        if (!isLoggedIn()) {
                            return;
                        }
                        const _el = document.getElementById(
                            'anchor-comment-body'
                        );
                        if (_el) {
                            editorRef?.current?.focus();
                            _el.scrollIntoView({
                                block: 'start',
                                behavior: 'smooth',
                            });
                        }
                    }}
                    isCommunityDiscussionType={isCommunityDiscussionType}
                    showShareLabel
                    className="left-aligned-bar"
                />
            </View>
        </View>
    );
};
